<p-toast></p-toast>

<div class="top-bar-categories flex align-orders-center">
  <div class="title flex align-orders-center mr-auto">
    <i _ngcontent-serverapp-c11="" class="fas fa-warehouse mr-3"></i>
    <h5>Mi Flota</h5>
  </div>
</div>
<div class="col-lg-12 mt-4">
  <p-card>
    <p-table
      [first]="first"
      [value]="vehicles"
      [paginator]="true"
      (onLazyLoad)="fetchVehicles($event)"
      [rows]="rows"
      [loading]="loading"
      [lazy]="true"
      [totalRecords]="totalRows"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} registros"
      [rowsPerPageOptions]="[10, 25, 50]"
      styleClass="p-datatable-striped p-datatable-sm"
      [tableStyle]="{ 'min-width': '15rem' }"
      responsiveLayout="stack"
      [breakpoint]="'800px'"
      [columnResizeMode]="'expand'"
      class="custom-stack-table"
    >
      <ng-template pTemplate="caption">
        <div style="display: flex; justify-content: end">
          <button
            (click)="openVehicleModal(VehicleAction.CREATE)"
            pButton
            label="Añadir vehículo"
            class="p-button-sm"
            icon="pi pi-plus"
          ></button>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="patent">
            Patente <p-sortIcon field="patent"></p-sortIcon>
          </th>
          <th pSortableColumn="codeChasis">
            VIN <p-sortIcon field="codeChasis"></p-sortIcon>
          </th>
          <th pSortableColumn="typeImp">
            Tipo <p-sortIcon field="typeImp"></p-sortIcon>
          </th>
          <th pSortableColumn="brand">
            Marca <p-sortIcon field="brand"></p-sortIcon>
          </th>
          <th pSortableColumn="model">
            Modelo <p-sortIcon field="model"></p-sortIcon>
          </th>
          <th pSortableColumn="manufactureYear">
            Año <p-sortIcon field="manufactureYear"></p-sortIcon>
          </th>
          <th>Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <!-- <th></th> -->
          <th pSortableColumn="patent">
            <div
              class="flex justify-content-between align-items-center"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center">
                Patente
                <p-sortIcon field="patent"></p-sortIcon>
              </div>
              <!--<p-columnFilter
                type="text"
                field="patent"
                display="menu"
                class="ml-auto"
              ></p-columnFilter> -->
            </div>
          </th>
          <th pSortableColumn="codeChasis">
            <div
              class="flex justify-content-between align-items-center"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center">
                VIN
                <p-sortIcon field="codeChasis"></p-sortIcon>
              </div>
              <!--
              <p-columnFilter
                type="text"
                field="codeChasis"
                display="menu"
                class="ml-auto"
              ></p-columnFilter> -->
            </div>
          </th>
          <th pSortableColumn="typeImp">
            <div
              class="flex justify-content-between align-items-center"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center">
                Tipo
                <p-sortIcon field="typeImp"></p-sortIcon>
              </div>
              <!--
              <p-columnFilter
                type="text"
                field="typeImp"
                display="menu"
                class="ml-auto"
              ></p-columnFilter> -->
            </div>
          </th>
          <th pSortableColumn="brand">
            <div
              class="flex justify-content-between align-items-center"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center">
                Marca
                <p-sortIcon field="brand"></p-sortIcon>
              </div>
              <!--
              <p-columnFilter
                type="text"
                field="brand"
                display="menu"
                class="ml-auto"
              ></p-columnFilter> -->
            </div>
          </th>
          <th pSortableColumn="model">
            <div
              class="flex justify-content-between align-items-center"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center">
                Modelo
                <p-sortIcon field="model"></p-sortIcon>
              </div>
              <!--
              <p-columnFilter
                type="text"
                field="model"
                display="menu"
                class="ml-auto"
              ></p-columnFilter>
              -->
            </div>
          </th>
          <th pSortableColumn="manufactureYear">
            <div
              class="flex justify-content-between align-items-center"
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div style="display: flex; align-items: center">
                Año
                <p-sortIcon field="manufactureYear"></p-sortIcon>
              </div>
              <!--
              <p-columnFilter
                type="text"
                field="manufactureYear"
                display="menu"
                class="ml-auto"
              ></p-columnFilter> -->
            </div>
          </th>
          <th>Acciones</th>
        </tr>
        <tr>
          <!--<th style="width: 4rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th> -->
          <th>
            <p-columnFilter
              type="text"
              class="w-full"
              field="patent"
              placeholder="Buscar por Patente"
              [showMenu]="false"
              [showClearButton]="false"
            ></p-columnFilter>
          </th>
          <th>
            <p-columnFilter
              type="text"
              class="w-full"
              field="codeChasis"
              placeholder="Buscar por VIN"
              [showMenu]="false"
              [showClearButton]="false"
            ></p-columnFilter>
          </th>
          <th>
            <!--
            <input
              pInputText
              type="text"
              placeholder="Buscar por tipo"
              class="w-full"
            />-->
          </th>
          <th>
            <!--
            <input
              pInputText
              type="text"
              placeholder="Buscar por marca"
              class="w-full"
            />-->
          </th>
          <th>
            <p-columnFilter
              type="text"
              class="w-full"
              field="model"
              placeholder="Buscar por modelo"
              [showMenu]="false"
              [showClearButton]="false"
            ></p-columnFilter>
          </th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-vehicle>
        <tr>
          <td
            [ngClass]="{
              'hidden p-0': !vehicle.username && isMobile,
              'p-1 border-bottom-1 border-solid border-gray-200':
                vehicle.username
            }"
          >
            <div class="p-column-title font-bold">Patente</div>
            <div class="md:col-12 col-6 p-0">
              {{ vehicle.patent }}
            </div>
          </td>
          <td
            [ngClass]="{
              'hidden p-0': !vehicle.codeChasis && isMobile,
              'p-1 border-bottom-1 border-solid border-gray-200':
                vehicle.codeChasis
            }"
          >
            <div class="p-column-title font-bold">VIN</div>
            <div class="md:col-12 col-6 p-0">
              {{ vehicle.codeChasis }}
            </div>
          </td>
          <td
            [ngClass]="{
              'hidden p-0': !vehicle.typeImp && isMobile,
              'p-1 border-bottom-1 border-solid border-gray-200':
                vehicle.typeImp
            }"
          >
            <div class="p-column-title font-bold">Tipo</div>
            <div class="md:col-12 col-6 p-0">
              {{ vehicle.typeImp }}
            </div>
          </td>
          <td
            [ngClass]="{
              'hidden p-0': !vehicle.brand && isMobile,
              'p-1 border-bottom-1 border-solid border-gray-200': vehicle.brand
            }"
          >
            <div class="p-column-title font-bold">Marca</div>
            <div class="md:col-12 col-6 p-0">
              {{ vehicle.brand }}
            </div>
          </td>
          <td
            [ngClass]="{
              'hidden p-0': !vehicle.model && isMobile,
              'p-1 border-bottom-1 border-solid border-gray-200': vehicle.model
            }"
          >
            <div class="p-column-title font-bold">Modelo</div>
            <div class="md:col-12 col-6 p-0">
              {{ vehicle.model }}
            </div>
          </td>
          <td
            [ngClass]="{
              'hidden p-0': !vehicle.manufactureYear && isMobile,
              'p-1 border-bottom-1 border-solid border-gray-200':
                vehicle.manufactureYear
            }"
          >
            <div class="p-column-title font-bold">Año</div>
            <div class="md:col-12 col-6 p-0">
              {{ vehicle.manufactureYear }}
            </div>
          </td>
          <td
            class="justify-content-center gap-3"
            [ngClass]="{
              'border-gray-400 border-bottom-3': isMobile
            }"
          >
            <button
              pButton
              pRipple
              pTooltip="Eliminar"
              tooltipPosition="top"
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger p-button-sm"
              (click)="confirmDeleteVehicle($event, vehicle._id)"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-confirmDialog></p-confirmDialog>
  </p-card>
</div>
